import { Fetch } from 'lib';
import type { Catalog } from 'types';

type RequestResponses = Catalog;

type RequestParameters = {
  id: string;
};

const getCatalog = async (params: RequestParameters) =>
  await Fetch<RequestResponses, RequestParameters>({
    url: 'adminCatalog/getCatalog',
    params,
  });

export { getCatalog };
